import type { ExperienceManifest } from '../../types'

export const manifest: ExperienceManifest = {
  version: '1.0.0',
  schemaVersion: '1.0.0',
  minimumFrameworkVersion: '1.0.0',
  capabilities: {
    supportsAudio: false,
    supportsInteraction: true,
    supportsReplay: true,
    supportsReducedMotion: true,
    supportsLocalization: false,
    supportsAnalytics: true,
    supportsCelebration: false,
  },
  metadata: {
    id: 'sunrise',
    name: 'Sunrise Reflection',
    description: 'A peaceful, gradient-driven morning sequence with breathing guidance.',
    category: 'entrance',
    themePreference: 'both',
  },
  eligibility: {
    check: (context) => context.timeOfDay === 'morning',
    cooldownMs: 20 * 60 * 60 * 1000,
    basePriority: 80,
  },
  ComponentLoader: () => import('./component'),
  preload: async () => Promise.resolve(),
}

export default manifest
